import axiosInstance from "./axiosInstance";

// Visible test execution
export const runExecutor = async ({ labInternalId, questionId, language, code }) => {
  const res = await axiosInstance.post("/executor/run", {
    labInternalId,
    questionId,
    language,
    code
  });
  return res.data;
};

// Final submit
export const submitExecutor = async ({ labInternalId, questionId, language, code }) => {
  const res = await axiosInstance.post("/executor/submit", {
    labInternalId,
    questionId,
    language,
    code
  });
  return res.data;
};
